import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const peopleManagementRouter = [
  {
    path: 'people',
    component: DummyRouter,
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.PeopleView,
    },
    children: [
      {
        path: '',
        component: () => import('@/features/peopleManagement/list/PeopleListView.vue'),
        meta: { permissionAction: PermissionActions.PeopleView },
      },
      {
        path: ':personId',
        component: () => import('@/features/peopleManagement/view/PeopleView.vue'),
        meta: { permissionAction: PermissionActions.PeopleView },
        children: [
          {
            path: '',
            component: () =>
              import('@/features/peopleManagement/view/dashboard/PeopleViewDashboard.vue'),
            meta: { permissionAction: PermissionActions.PeopleView },
          },
          {
            path: 'details',
            component: () =>
              import('@/features/peopleManagement/view/details/PeopleViewDetails.vue'),
            meta: { permissionAction: PermissionActions.PeopleView },
          },
          {
            path: 'events',
            component: () => import('@/features/peopleManagement/view/events/PeopleViewEvents.vue'),
            meta: { permissionAction: PermissionActions.PeopleView },
          },
          {
            path: 'email',
            component: () => import('@/features/peopleManagement/view/email/PeopleViewEmails.vue'),
            meta: { permissionAction: PermissionActions.PeopleView },
          },
        ],
      },
      {
        path: 'new',
        component: () => import('@/features/peopleManagement/new/PeopleNewView.vue'),
        meta: { permissionAction: PermissionActions.PeopleCreate },
      },
    ],
  },
]
